import {BaseEntity} from "../../entities/BaseEntity";
import alasql from "alasql";
import { StateService } from "@uirouter/angularjs";
import {ImportModel} from "../../models/import/ImportModel";

export class ImportSummaryCtrl<T extends BaseEntity>{
    public static $inject = ['$scope','$state','ImportModel'];
    constructor(public $scope:any, public stateService:StateService, public model:ImportModel<T>) {
        this.$scope.vm = this;
    }
    exportSkipped():void{
        alasql('SELECT * INTO CSV("skippedImport.csv",{headers:true,separator:","}) FROM ?', [this.model.skipped]);
    }
    startOver():void{
        this.stateService.go(this.model.getRoute("fileupload"));
    }
}
